/* eslint-disable react/forbid-prop-types */
/* eslint-disable-next-line max-len */
import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { Row, Col, Card, CardText, CardBody, Table } from 'reactstrap';
import PropTypes, { element, object } from 'prop-types';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { setCurrencyFormat } from '../../../../utils/helpers';
import { colorArr, sortByOptions } from '../../helper';

const RepurchaseRateTable = ({ dataToShowForDatesSelected, month,
  title, filterBasedOnFilter, categorisedBasedOn, firstColumn, currentlyShow, optionShow }) => {
  const { t } = useTranslation('common');
  const categorisedBasedOnRef = useRef({ categorisedBasedOn });

  const [selectedOptions, setSelectedOptions] = useState([])
  const [sortBySelected, setSortBySelected] = useState(sortByOptions[1])
  const allCategories = {}
  const currentDataByCategory = {};
  const tableHeader = [];

  useEffect(() => {
    if (categorisedBasedOnRef?.current?.categorisedBasedOn !== categorisedBasedOn) {
      setSelectedOptions([])
    }
  }, [categorisedBasedOn])

  const changeFilter = (value) => {
    setSelectedOptions(value)
  };

  dataToShowForDatesSelected.forEach((item) => {
    if (item && currentDataByCategory[item?.category]) {
      currentDataByCategory[item?.category]?.push(item)
    } else if (item) {
      if (!item?.category || item?.category === 'null') {
        currentDataByCategory?.['N/A']?.push(item)
      } else {
        currentDataByCategory[item?.category] = [item]
      }
    }
  });

  const currentMonthCat = Object.keys(currentDataByCategory);
  let dataToPlot = [];
  const options = [];

  const reduceCallbackForMonthly = (acc, day) => {
    const date = moment(`${day.month}-${day?.year}`, 'MMM-YYYY');
    const MonthYear = date.format('MMM-YYYY');
    if (acc[MonthYear]) {
      acc?.[MonthYear]?.push(day)
    } else {
      acc[MonthYear] = [day]
    }

    if (day && !allCategories[day?.category]) {
      if (!day?.category || day?.category === 'null') {
        allCategories['N/A'] = 'N/A';
      } else {
        allCategories[day?.category] = day?.category
      }
    }
    return acc
  }

  const reduceCallbackForYearly = (acc, day) => {
    const date = moment(`${day.month}-${day?.year}`, 'MMM-YYYY');
    const MonthYear = date.format('YYYY');
    if (acc[MonthYear]) {
      acc?.[MonthYear]?.push(day)
    } else {
      acc[MonthYear] = [day]
    }

    if (day && !allCategories[day?.category]) {
      if (!day?.category || day?.category === 'null') {
        allCategories['N/A'] = 'N/A';
      } else {
        allCategories[day?.category] = day?.category
      }
    }
    return acc
  }

  const reduceCallbackForQuarterly = (acc, day) => {
    const date = moment(`${day.month}-${day?.year}`, 'MMM-YYYY');
    const MonthYear = date.format('YYYY');

    for( let i = 0; i < month.length; i += 1 )
    {
      const [month1, month2, month3] = month[i].split('-');
      if (day?.month === month1) {
        if (acc[`${month[i]}`]) {
          acc?.[`${month[i]}`]?.push(day)
        } else {
          acc[`${month[i]}`] = [day]
        }
      }
      else if(day?.month === month2)
      {
        if (acc[`${month[i]}`]) {
          acc?.[`${month[i]}`]?.push(day)
        } else {
          acc[`${month[i]}`] = [day]
        }
      }
      else if(day?.month === month3)
      {
        if (acc[`${month[i]}`]) {
          acc?.[`${month[i]}`]?.push(day)
        } else {
          acc[`${month[i]}`] = [day]
        }
      }
    }    

    if (day && !allCategories[day?.category]) {
      if (!day?.category || day?.category === 'null') {
        allCategories['N/A'] = 'N/A';
      } else {
        allCategories[day?.category] = day?.category
      }
    }
    return acc
  }

  const getRepurchaseRate = (toralCus, repeatCus) => {
    let v = 0;
    if (repeatCus > 0) {
      v = (( repeatCus / toralCus) * 100).toFixed(2) || '0.00';
    }
    else {
      v = 0.00;
    }
    return v;
  }

  const getColorCode = (salesPer) => {
    let colorCode;

    if (salesPer < 0) {
      const negValue = salesPer.split('-');
      if (negValue[1] < 10) {
        colorCode = colorArr[0].toString();
      }
      else if (negValue[1] > 10 && negValue[1] < 20) {
        colorCode = colorArr[1].toString();
      }
      else if (negValue[1] > 20 && negValue[1] < 30) {
        colorCode = colorArr[2].toString();
      }
      else if (negValue[1] > 30 && negValue[1] < 40) {
        colorCode = colorArr[3].toString();
      }
      else if (negValue[1] > 40 && negValue[1] < 50) {
        colorCode = colorArr[4].toString();
      }
      else if (negValue[1] > 50 && negValue[1] < 60) {
        colorCode = colorArr[5].toString();
      }
      else if (negValue[1] > 60 && negValue[1] < 70) {
        colorCode = colorArr[6].toString();
      }
      else if (negValue[1] > 70 && negValue[1] < 80) {
        colorCode = colorArr[7].toString();
      }
      else if (negValue[1] > 80 && negValue[1] < 90) {
        colorCode = colorArr[8].toString();
      }
      else if (negValue[1] > 90) {
        colorCode = colorArr[9].toString();
      }
    }
    else if (salesPer > 0) {
      if (salesPer < 1) {
        colorCode = colorArr[10].toString();
      }
      else if (salesPer >= 1 && salesPer < 2) {
        colorCode = colorArr[11].toString();
      }
      else if (salesPer >= 2 && salesPer < 3) {
        colorCode = colorArr[12].toString();
      }
      else if (salesPer >= 3 && salesPer < 4) {
        colorCode = colorArr[13].toString();
      }
      else if (salesPer >= 4 && salesPer < 5) {
        colorCode = colorArr[14].toString();
      }
      else if (salesPer >= 5 && salesPer < 6) {
        colorCode = colorArr[15].toString();
      }
      else if (salesPer >= 6 && salesPer < 7) {
        colorCode = colorArr[16].toString();
      }
      else if (salesPer >= 7 && salesPer < 8) {
        colorCode = colorArr[17].toString();
      }
      else if (salesPer >= 8 && salesPer < 9) {
        colorCode = colorArr[18].toString();
      }
      else if (salesPer >= 9) {
        colorCode = colorArr[19].toString();
      }
    }
    else {
      colorCode = colorArr[20].toString();
    }
    return colorCode;
  }

  if(optionShow?.value === 'monthly')
  {
    for (let i = 0; i < currentMonthCat.length; i += 1) {
        const cat = currentMonthCat[i];
        const currentMonth = currentDataByCategory?.[cat] ?? [];
        let currentYearMonthMax = 0;
        currentMonth?.forEach((item) => {
        currentYearMonthMax += Number(item.amount)
        }
        );
        const currentYearMonthDayWise = currentMonth?.reduce(reduceCallbackForMonthly, {})
        const categoryWiseAmountTotal = Object.keys(currentYearMonthDayWise).reduce((acc, monthyear) => {
        const totalCustomer = currentYearMonthDayWise[monthyear]?.reduce((accum, item) => Number(Number(Number(accum) +
            Number(item.totalCustomer)).toFixed(2)), 0);
        const repeatCustomer = currentYearMonthDayWise[monthyear]?.reduce((accRet, itemRet) =>
            Number(Number(accRet) + Number(itemRet.repeatCustomer)), 0)        

        const repurchaseRate = getRepurchaseRate(totalCustomer, repeatCustomer) ?? 0.00;
        const cardColorCode = getColorCode(repurchaseRate);
        acc[monthyear] = {
            TotalCustomer: totalCustomer, 
            RepeatCustomer: repeatCustomer,
            RepurchaseRate: repurchaseRate,
            ColorCode: cardColorCode
        };
        return acc
        }, {})
        options.push({
        value: cat, label: cat
        })
        dataToPlot.push({
        title: cat,
        categoryWiseAmountTotal,
        currentYearMonthMax: currentYearMonthMax > 0 ? currentYearMonthMax : 0
        })

    }
  }
  else if(optionShow?.value === 'yearly')
  {
    for (let i = 0; i < currentMonthCat.length; i += 1) {
        const cat = currentMonthCat[i];
        const currentMonth = currentDataByCategory?.[cat] ?? [];
        let currentYearMonthMax = 0;
        currentMonth?.forEach((item) => {
        currentYearMonthMax += Number(item.amount)
        }
        );
        const currentYearMonthDayWise = currentMonth?.reduce(reduceCallbackForYearly, {})
        
        const categoryWiseAmountTotal = Object.keys(currentYearMonthDayWise).reduce((acc, monthyear) => {
        const totalCustomer = currentYearMonthDayWise[monthyear]?.reduce((accum, item) => Number(Number(Number(accum) +
            Number(item.totalCustomer)).toFixed(2)), 0);
        const repeatCustomer = currentYearMonthDayWise[monthyear]?.reduce((accRet, itemRet) =>
            Number(Number(accRet) + Number(itemRet.repeatCustomer)), 0)        

        const repurchaseRate = getRepurchaseRate(totalCustomer, repeatCustomer) ?? 0.00;
        const cardColorCode = getColorCode(repurchaseRate);
        acc[monthyear] = {
            TotalCustomer: totalCustomer, 
            RepeatCustomer: repeatCustomer,
            RepurchaseRate: repurchaseRate,
            ColorCode: cardColorCode
        };
        return acc
        }, {})
        options.push({
        value: cat, label: cat
        })

        dataToPlot.push({
        title: cat,
        categoryWiseAmountTotal,
        currentYearMonthMax: currentYearMonthMax > 0 ? currentYearMonthMax : 0
        })

    }
  }
  else if(optionShow?.value === 'quarterly')
  {
    for (let i = 0; i < currentMonthCat.length; i += 1) {
        const cat = currentMonthCat[i];
        const currentMonth = currentDataByCategory?.[cat] ?? [];
        let currentYearMonthMax = 0;
        currentMonth?.forEach((item) => {
        currentYearMonthMax += Number(item.amount)
        }
        );
        const currentYearMonthDayWise = currentMonth?.reduce(reduceCallbackForQuarterly, {})
        const categoryWiseAmountTotal = Object.keys(currentYearMonthDayWise).reduce((acc, monthyear) => {
        const totalCustomer = currentYearMonthDayWise[monthyear]?.reduce((accum, item) => Number(Number(Number(accum) +
            Number(item.totalCustomer)).toFixed(2)), 0);
        const repeatCustomer = currentYearMonthDayWise[monthyear]?.reduce((accRet, itemRet) =>
            Number(Number(accRet) + Number(itemRet.repeatCustomer)), 0)        

        const repurchaseRate = getRepurchaseRate(totalCustomer, repeatCustomer) ?? 0.00;
        const cardColorCode = getColorCode(repurchaseRate);
        acc[monthyear] = {
            TotalCustomer: totalCustomer, 
            RepeatCustomer: repeatCustomer,
            RepurchaseRate: repurchaseRate,
            ColorCode: cardColorCode
        };
        return acc
        }, {})
        options.push({
        value: cat, label: cat
        })

        dataToPlot.push({
        title: cat,
        categoryWiseAmountTotal,
        currentYearMonthMax: currentYearMonthMax > 0 ? currentYearMonthMax : 0
        })

    }
  }

  if (selectedOptions?.length) {
    const selected = selectedOptions?.reduce((acc, item) => {
      acc[item?.value] = item.value
      return acc
    }, {})
    dataToPlot = dataToPlot.filter(item => selected[item.title])
  }

  const sortBy = sortBySelected?.value;
  if (sortBy === 'title') {
    dataToPlot = dataToPlot?.sort((a, b) =>
      a?.[sortBy]?.toLowerCase() > b?.[sortBy]?.toLowerCase() ? 1 : -1)
  } else {
    dataToPlot = dataToPlot?.sort((a, b) =>
      a?.[sortBy] < b?.[sortBy] ? 1 : -1)
  }
  return (
    <Col xs="12">
      <Card className="pb-3 show-categ-daily-sales">
        <CardBody>
          <div className="card__title row align-items-center">
            <h5 className="bold-text col-md-5">{title}</h5>
            <div className="form__form-group mb-0 col-md-7" id='dvTable'>
              <div className="row justify-content-center align-items-center">
                <div className="col-6">
                  <span className="form__form-group-label font-weight-bold">
                    {`Select ${currentlyShow?.label}`}</span>
                  <div className="form__form-group-field">
                    <Select
                      value={selectedOptions}
                      options={options}
                      clearable={false}
                      placeholder={`Select ${currentlyShow?.label}`}
                      className="select_filter"
                      onChange={changeFilter}
                      classNamePrefix="react-select"
                      isMulti
                    />
                  </div>
                </div>
                {/* <div className="col-6">
                  <span className="form__form-group-label font-weight-bold">Sort By</span>
                  <div className="form__form-group-field">
                    <Select
                      value={sortBySelected}
                      options={sortByOptions}
                      clearable={false}
                      placeholder="Sort By"
                      className="select_filter"
                      onChange={setSortBySelected}
                      classNamePrefix="react-select"
                    />
                  </div>
                </div> */}
              </div>
            </div>
            <Table responsive striped className="dashboard__table-orders" width="100%">
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', minWidth: '150px'  }}>{firstColumn}</th>
                  {month.map((item, index) => (
                    <th style={{ textAlign: 'center', }}>{item}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dataToPlot?.length ? dataToPlot?.map(dataValue => (
                  <tr>
                    <td style={{ paddingTop: '2px', paddingBottom: '2px', }}>{dataValue.title}
                    </td>
                    {month.map((item, index) => (
                      <td style={{
                        paddingTop: '2px', paddingBottom: '2px', paddingLeft: '3px',
                        paddingRight: '3px', marginLeft: '0px', marginRight: '0px',
                      }}>
                        <Card body style={{
                          background: dataValue?.categoryWiseAmountTotal?.[item]?.RepurchaseRate > 0
                            ? dataValue?.categoryWiseAmountTotal?.[item]?.ColorCode : colorArr[20],
                          
                           marginBottom: '0px',
                          marginTop: '0px', paddingTop: '3px', paddingBottom: '3px',
                          paddingRight: '6px'
                        }}>
                          <CardText style={{
                            color: '#000000', fontSize: '11px', textAlign: 'right', paddingBottom: '0px',
                            paddingTop: '0px', marginBottom: '0px'
                          }}>
                            {setCurrencyFormat(dataValue?.categoryWiseAmountTotal?.[item]?.RepurchaseRate, false)} %
                          </CardText>                          
                        </Card>

                      </td>
                    ))}
                  </tr>
                )) : 'No data to display'}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

RepurchaseRateTable.propTypes = {
  dataToShowForDatesSelected: PropTypes.array.isRequired,
  firstColumn: PropTypes.string,
  month: PropTypes.object.isRequired,
  title: PropTypes.string,
  filterBasedOnFilter: PropTypes.func.isRequired,
  categorisedBasedOn: PropTypes.string,
  currentlyShow: PropTypes.object.isRequired,
  optionShow: PropTypes.object.isRequired
};

RepurchaseRateTable.defaultProps = {
  title: 'Repurchase Rate',
  firstColumn: 'Product Category',
  categorisedBasedOn: 'category',
}

export default RepurchaseRateTable;

